const STORAGE_KEY = "ko-cart-v1";

export function readCart() {
  try {
    const value = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
    return Array.isArray(value) ? value.filter(isCartLine) : [];
  } catch {
    return [];
  }
}

export function saveCart(cart) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(cart));
  window.dispatchEvent(new CustomEvent("ko-cart-changed", { detail: cart }));
}

export function addToCart(product, quantity = 1) {
  quantity = Math.max(1, Math.min(99, Math.trunc(Number(quantity)) || 1));
  const cart = readCart();
  const current = cart.find((line) => line.id === product.id);
  if (current) current.quantity = Math.min(99, current.quantity + quantity);
  else cart.push({ id: product.id, quantity: Math.min(99, quantity), priceCents: product.priceCents, version: product.version });
  const line = cart.find((item) => item.id === product.id);
  line.priceCents = product.priceCents;
  line.version = product.version;
  saveCart(cart);
  return cart;
}

export function setQuantity(id, quantity) {
  const cart = readCart();
  const line = cart.find((item) => item.id === id);
  if (!line) return cart;
  if (quantity < 1) return removeFromCart(id);
  line.quantity = Math.max(1, Math.min(99, Math.trunc(Number(quantity)) || 1));
  saveCart(cart);
  return cart;
}

export function acceptCurrentPrice(product) {
  const cart = readCart();
  const line = cart.find((item) => item.id === product.id);
  if (line) {
    line.priceCents = product.priceCents;
    line.version = product.version;
    saveCart(cart);
  }
}

export function removeFromCart(id) {
  const cart = readCart().filter((item) => item.id !== id);
  saveCart(cart);
  return cart;
}

export function clearCart() {
  saveCart([]);
}

function isCartLine(item) {
  return item && typeof item.id === "string" && Number.isInteger(item.quantity) && item.quantity >= 1 && item.quantity <= 99
    && Number.isSafeInteger(item.priceCents) && Number.isSafeInteger(item.version);
}
